import axios from "axios";
import { SectionsResponse } from "types/sections";

export default async function fetchSections(): Promise<SectionsResponse> {
  const { data } = await axios.get(
    `${process.env.NEXT_PUBLIC_API_URL}discovery/sectionslist`
  );

  return data;
}
